import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Form for rule_type='lm_value'.
 * No input — target = M-1 value as-is.
 * rule_value shape: {} (empty object).
 */
const LmValueRuleForm = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  // Ensure rule_value is at least an empty object so save works
  React.useEffect(() => {
    if (value === null || value === undefined) {
      onChange({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="rounded-xl bg-muted/40 border border-border px-4 py-3">
      <div className="text-sm font-medium text-foreground">
        {t('admin.objectiveRules.form.lmValue.title', 'Use last-month value as target')}
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        {t(
          'admin.objectiveRules.form.lmValue.help',
          'No input required. The target for the current month equals the result of the previous month, unchanged.'
        )}
      </p>
    </div>
  );
};

export default LmValueRuleForm;
